import { render, staticRenderFns } from "./department-process-view.vue?vue&type=template&id=660964f8"
import script from "./department-process-view.vue?vue&type=script&lang=js"
export * from "./department-process-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports